
import Buyer from '@/components/Buyer/Buyer'
import BuyersSummary from '@/components/Buyer/BuyersSummary'
import CharitiesSummary from '@/components/Charity/CharitiesSummary'
import Charity from '@/components/Charity/Charity'
import CharityAdd from '@/components/Charity/CharityAdd'
import Dashboard from '@/components/Dashboard'
// import Emails from '@/components/Emails/Emails'
import HomePage from '@/components/HomePage'
import Login from '@/components/Login/Login'
import NotFound from '@/components/NotFound'
import NewUserSetup from '@/components/Login/NewUserSetup'
import Payables from '@/components/Payables/Payables'
import Reports from '@/components/Reports/Reports'
import ResetPassword from '@/components/ResetPassword'
import Router from 'vue-router'
import SourceSummary from '@/components/Source/SourceSummary'
import TowingCompany from '@/components/TowingCompany/TowingCompany'
import TowingCompanysSummary from '@/components/TowingCompany/TowingCompanysSummary'
import UsersSummary from '@/components/Users/UsersSummary'
import Vehicle from '@/components/Vehicle/Vehicle'
import DefaultPage from '@/components/DefaultPage'
import VehicleAdd from '@/components/Vehicle/VehicleAdd'
import VehiclesSummary from '@/components/Vehicle/VehiclesSummary'
import CharityView from '@/components/Charity/CharityView'
import Donation from '@/components/Widgets/Donation'
import CharityProspect from '@/components/Widgets/CharityProspect'
import CharityProspectVerification from '@/components/Widgets/CharityProspectVerification'
import CharityViewPreview from '@/components/PreviewAccount/CharityViewPreview'
import DonationPreview from '@/components/PreviewAccount/DonationPreview'
import DonationWidget from '@/components/Widgets/DonationWidget'
import DonationWidgetCHC from '@/components/Widgets/DonationWidgetCHC'
import DonationWidgetFullForm from '@/components/Widgets/DonationWidgetFullForm'
import FormPortal from '@/components/Widgets/FormPortal'

import Vue from 'vue'
import auth from '@/auth'

const Emails = () => import('@/components/Emails/Emails')

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/app',
      component: HomePage,
      children: [
        {
          path: '',
          name: 'App',
          component: DefaultPage
        },
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            requiresAdmin: true,
          }
        },
        {
          path: 'charities',
          name: 'CharitiesSummary',
          component: CharitiesSummary,
          meta: {
            requiresAdmin: true,
          }
        },
        {
          path: 'charities/add',
          name: 'CharityAdd',
          component: CharityAdd,
          meta: {
            requiresAdmin: true,
          }
        },
        {
          path: 'charities/:charityId',
          name: 'Charity',
          component: Charity,
          props: true,
          meta: {
            requiresAdmin: true,
          }
        },
        {
          path: 'vehicles',
          name: 'VehiclesSummary',
          component: VehiclesSummary,
          props: true,
          meta: {
            requiresAdminCall: true
          }
        },
        {
          path: 'vehicles/add',
          name: 'VehicleAdd',
          component: VehicleAdd,
          meta: {
            requiresAdminCall: true
          }
        },
        {
          path: 'vehicles/:vehicleId',
          name: 'Vehicle',
          component: Vehicle,
          props: true
        },
        {
          path: 'buyers',
          name: 'BuyersSummary',
          component: BuyersSummary,
          meta: {
            requiresAdmin: true,
          }
        },
        {
          path: 'sources',
          name: 'SourceSummary',
          component: SourceSummary,
          meta: {
            requiresAdmin: true,
          }
        },
        {
          path: 'users',
          name: 'UsersSummary',
          component: UsersSummary,
          meta: {
            requiresAdmin: true,
          }
        },
        {
          path: 'buyers/:buyerId',
          name: 'Buyer',
          component: Buyer,
          props: true,
          meta: {
            requiresAdmin: true,
          }
        },
        {
          path: 'towing_companies',
          name: 'TowingCompaniesSummary',
          component: TowingCompanysSummary,
          meta: {
            requiresAdmin: true,
          }
        },
        {
          path: 'towing_companies/:towingCompanyId',
          name: 'TowingCompany',
          component: TowingCompany,
          props: true,
          meta: {
            requiresAdmin: true,
          }
        },
        {
          path: 'payables',
          name: 'Payables',
          component: Payables,
          props: true,
          meta: {
            requiresAdmin: true,
          }
        },
        {
          path: 'reports',
          name: 'Reports',
          component: Reports,
          meta: {
            requiresAdmin: true,
          }
        },
        {
          path: 'emails',
          name: 'Emails',
          component: Emails,
          meta: {
            requiresAdmin: true,
          }
        },
        {
          path: 'reset-password',
          name: 'ResetPassword',
          component: ResetPassword
        },
        {
          path: 'charity-view',
          name: 'CharityView',
          component: CharityView,
          meta: {
            requiresCharity: true,
          }
        },
        {
          path: 'preview-vehicles',
          name: 'PreviewAccount',
          component: CharityViewPreview,
          meta: {
            requiresPreview: true,
          }
        },
        {
          path: 'donation',
          name: 'Donation',
          component: Donation,
          meta: {
            requiresCharity: true,
          }
        },
        {
          path: 'preview-donation',
          name: 'DonationPreview',
          component: DonationPreview,
          meta: {
            requiresPreview: true,
          }
        }
      ]
    },
    {
      path: '/',
      redirect: '/app'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        external: true,
      }
    },
    {
      path: '/register/:token',
      name: 'NewUserSetup',
      component: NewUserSetup,
      props: true,
      meta: {
        external: true,
      }
    },
    {
      path: '/charity-prospect/',
      name: 'CharityProspect',
      component: CharityProspect,
      meta: {
        external: true,
      }
    },
    {
      path: '/charity-prospect/:token',
      name: 'CharityProspectVerification',
      component: CharityProspectVerification,
      meta: {
        external: true,
      }
    },
    {
      path: '/full/donate/:id/:token',
      name: 'DonationWidgetFullForm',
      component: DonationWidgetFullForm,
      meta: {
        external: true,
      }
    },
    {
      path: '/full/donate',
      name: 'CHCDonationWidgetFullForm',
      component: DonationWidgetFullForm,
      meta: {
        external: true,
      }
    },
    {
      path: '/donate/:id/:token',
      name: 'DonationWidget',
      component: DonationWidget,
      meta: {
        external: true,
      }
    },
    {
      path: '/donate',
      name: 'DonationWidgetCHC',
      component: DonationWidgetCHC,
      meta: {
        external: true,
      }
    },
    {
      path: '/forms/:token',
      name: 'FormPortal',
      component: FormPortal,
      meta: {
        external: true,
      }
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
      meta: {
        external: true,
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!to.meta.external && (!auth.user || !auth.user.authenticated)) {
    next({name: 'Login'})
  } else if (to.meta.requiresAdmin && auth.user.user_role !== 'admin') {
    next({name: 'App'})
  } else if (to.meta.requiresCharity && auth.user.user_role !== 'charity') {
    next({name: 'App'})
  } else if (to.meta.requiresPreview && auth.user.user_role !== 'charity_prospect') {
    next({name: 'App'})
  } else if (to.meta.requiresAdminCall && !(auth.user.user_role === 'call' || auth.user.user_role === 'admin')) {
    next({name: 'App'})
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router.js